// scroll-reveal.directive.ts

import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  OnDestroy
} from '@angular/core';

@Directive({
  selector: '[sipScrollReveal]'
})
export class ScrollRevealDirective implements OnInit, OnDestroy {

  @Input() sipDelay: number = 0; // delay in seconds (e.g. 0.08, 0.16)

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    const nativeEl = this.el.nativeElement as HTMLElement;

    // Set initial hidden state
    nativeEl.style.opacity = '0';
    nativeEl.style.transform = 'translateY(22px)';
    nativeEl.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    nativeEl.style.transitionDelay = `${this.sipDelay}s`;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            nativeEl.style.opacity = '1';
            nativeEl.style.transform = 'translateY(0)';
            this.observer.unobserve(nativeEl);
          }
        });
      },
      { threshold: 0.07 }
    );

    this.observer.observe(nativeEl);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}